/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProviderLightDto } from './ProviderLightDto';
import {
    ProviderLightDtoFromJSON,
    ProviderLightDtoFromJSONTyped,
    ProviderLightDtoToJSON,
    ProviderLightDtoToJSONTyped,
} from './ProviderLightDto';

/**
 * 
 * @export
 * @interface GetPatientPrescriptionFiltersResponseDto
 */
export interface GetPatientPrescriptionFiltersResponseDto {
    /**
     * Statuses
     * @type {Array<string>}
     * @memberof GetPatientPrescriptionFiltersResponseDto
     */
    statuses: Array<GetPatientPrescriptionFiltersResponseDtoStatusesEnum>;
    /**
     * Providers
     * @type {Array<ProviderLightDto>}
     * @memberof GetPatientPrescriptionFiltersResponseDto
     */
    providers: Array<ProviderLightDto>;
}


/**
 * @export
 */
export const GetPatientPrescriptionFiltersResponseDtoStatusesEnum = {
    Cancelled: 'cancelled',
    Paid: 'paid',
    Pending: 'pending'
} as const;
export type GetPatientPrescriptionFiltersResponseDtoStatusesEnum = typeof GetPatientPrescriptionFiltersResponseDtoStatusesEnum[keyof typeof GetPatientPrescriptionFiltersResponseDtoStatusesEnum];


/**
 * Check if a given object implements the GetPatientPrescriptionFiltersResponseDto interface.
 */
export function instanceOfGetPatientPrescriptionFiltersResponseDto(value: object): value is GetPatientPrescriptionFiltersResponseDto {
    if (!('statuses' in value) || value['statuses'] === undefined) return false;
    if (!('providers' in value) || value['providers'] === undefined) return false;
    return true;
}

export function GetPatientPrescriptionFiltersResponseDtoFromJSON(json: any): GetPatientPrescriptionFiltersResponseDto {
    return GetPatientPrescriptionFiltersResponseDtoFromJSONTyped(json, false);
}

export function GetPatientPrescriptionFiltersResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPatientPrescriptionFiltersResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': json['statuses'],
        'providers': ((json['providers'] as Array<any>).map(ProviderLightDtoFromJSON)),
    };
}

export function GetPatientPrescriptionFiltersResponseDtoToJSON(json: any): GetPatientPrescriptionFiltersResponseDto {
    return GetPatientPrescriptionFiltersResponseDtoToJSONTyped(json, false);
}

export function GetPatientPrescriptionFiltersResponseDtoToJSONTyped(value?: GetPatientPrescriptionFiltersResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statuses': value['statuses'],
        'providers': ((value['providers'] as Array<any>).map(ProviderLightDtoToJSON)),
    };
}

